export type RoleFlags = {
  isManager: boolean;
  isSuperAdmin: boolean;
  isGlobalAdmin: boolean;
  isZoneAdmin: boolean;
  isPBP: boolean;
  isTalentManager: boolean;
};

export function roleFlags(role?: string): RoleFlags {
  return {
    isManager: role === 'MANAGER',
    isSuperAdmin: role === 'SUPER_ADMIN',
    isGlobalAdmin: role === 'GlobalAdmin',
    isZoneAdmin: role === 'ZONE_ADMIN',
    isPBP: role === 'PBP',
    isTalentManager: role === 'TALENT_MANAGER',
  };
}
